<script setup lang="ts">
import logo from '@/assets/images/onenetwork_logo_bo.svg';
import bgLogin from '@/assets/loginbg.png';
import { computed, ref } from 'vue'
import { useToast } from 'primevue/usetoast'
import { AuthActionTypes, useAuthStore } from '@/onenetwork/stores/onenetwork.store.auth.ts'
import { Icon } from '@iconify/vue'
import { useRoute, useRouter } from 'vue-router'
import LoginLayout from '@/onenetwork/layouts/LoginLayout.vue';

const authStore = useAuthStore()

const toast = useToast();
const initialValues = ref({
  phone_number: '',
  password: '',
});

const router = useRouter()
const route = useRoute();

const resolver = (e: any) => {
  const errors: any = { phone_number: [], password: [] };

  if (!e.values.phone_number) {
    errors.phone_number.push({ type: 'required', message: 'Vui lòng nhập tài khoản.' });
  }

  if (!e.values.password) {
    errors.password.push({ type: 'required', message: 'Vui lòng nhập mật khẩu.' });
  }

  return {
    values: e.values,
    errors
  };
};

const loading = computed(() => {
  return authStore.action_type == AuthActionTypes.LOADING
})

const onFormSubmit = (form: any) => {

  try{
    if(!form.valid) throw new Error('False');
    authStore.login(form.values).then((res) => {
      toast.add({ severity: 'success', summary: 'Đăng nhập thành công', detail: `Chào mừng quay trở lại`, life: 2000});
      setTimeout(() => {
        router.push(route.query.redirect?.toString() || '/');
      }, 1000)
    })
    .catch((e: any) => {
      toast.add({ severity: 'error', summary: 'Đăng nhập thất bại', detail: `Tài khoản hoặc mật khẩu không chính xác, vui lòng đăng nhập lại`, life: 2000 });
    })
  } catch (e) {

    toast.add({ severity: 'error', summary: 'Đăng nhập thất bại', detail: `Tài khoản hoặc mật khẩu không chính xác, vui lòng đăng nhập lại`, life: 2000 });
  }

};
</script>

<template>
<div class="auth-page flex w-[100vw] h-[100vh] flex-col md:flex-row items-center">
  <LoginLayout />
  <div class="flex flex-1 h-[100vh] p-5 justify-center flex-col px-[16px]">
    <Form v-slot="$form"
          :initial-values="initialValues"
          :resolver="resolver"
          @submit="onFormSubmit" class="w-full md:w-[20vw] mx-auto ">
      <h3 class="font-bold text-xl mb-3">Đăng nhập</h3>
      <div class="flex flex-col mb-3">
        <div class="flex-1 text-[12px] mb-1">Số điện thoại:</div>
        <div class="flex-1">
          <InputText name="phone_number" type="text"  class="form-control py-[7px]" />
          <Message v-if="$form.phone_number?.invalid" severity="error"  variant="simple">{{ $form.phone_number.error.message }}</Message>
        </div>
      </div>
      <div class="flex flex-col mb-3">
        <div class="flex-1 text-[12px] mb-1">Mật khẩu:</div>
        <div class="flex-1">
          <InputText name="password" type="password"  class="form-control py-[7px]" />
          <Message v-if="$form.password?.invalid" severity="error"  variant="simple">{{ $form.password.error.message }}</Message>
        </div>
      </div>
      <div class="flex justify-between items-center">
        <Button type="submit" class="px-[40px] py-[10px] bg-[#ff6f00] text-white hover:bg-[#1E88E5] cursor-pointer" :disabled="loading">
          Đăng nhập <Icon icon="eos-icons:three-dots-loading" v-if="loading" />
        </Button>
        <div class="!ml-5">
          <!-- <a href="/auth/forget-pw" class="hover:text-slate-700 text-[12px]">Khôi phục mật khẩu</a> -->
          <router-link to="/auth/forget-pw" class="hover:text-slate-700 text-[12px]">Khôi phục mật khẩu</router-link>
        </div>
      </div>
    </Form>
    <br/>
    <br/>
    <br/>
  </div>
</div>
</template>

<style scoped>

</style>
